import { experienceBuilderApi } from 'api'

export const fetchRecommendations = (data: any) =>
  experienceBuilderApi.get<{ data: any[] }>('/marketing-capabilities/recommendations', {
    params: {
      ...data,
    },
  })
